<template>
  <div>
    <div class="container text-left">
      <div class="row">
        <div class="col">
          <button
            class="btn btn-link"
            data-toggle="modal"
            data-target="#createAccountGroupModal"
          >
            Add Group
          </button>
        </div>
      </div>
      <div
        v-for="group in accountGroups"
        :key="group.AccountGroup_Id"
        v-bind:id="group.AccountGroup_Id"
        class="row mt-4"
      >
        <div class="col">
          <div class="row">
            <div class="col-auto px-0">
              <i
                class="material-icons pointer"
                v-bind:id="group.AccountGroup_Id + 'dtoggleIcon'"
                data-toggle="collapse"
                v-bind:href="'#groupDetails' + group.AccountGroup_Id"
                role="button"
                aria-expanded="false"
                v-on:click="
                  $updateToggleIcon('#' + group.AccountGroup_Id + 'dtoggleIcon')
                "
                >add</i
              >
            </div>
            <div class="col">
              <h5
                class="pointer btn-link d-inline-block"
                v-on:click="editAccountGroup(group)"
              >
                {{ group.Name }}
              </h5>
              <h5
                v-if="group.Accounts.length != 1"
                class="text-secondary d-inline-block ml-2"
              >
                ({{ group.Accounts.length }} Accounts)
              </h5>
              <h5 v-else class="text-secondary d-inline-block ml-2">
                ({{ group.Accounts.length }} Account)
              </h5>
            </div>
            <div class="col-auto">
              <button
                class="btn btn-link"
                data-toggle="modal"
                data-target="#createAccountModal"
                v-on:click="addAccountToGroup(group.AccountGroup_Id)"
              >
                Add Account
              </button>
            </div>
          </div>
          <div style="height: 1px; background-color:gray;"></div>
          <div
            class="container collapse ml-4"
            v-bind:id="'groupDetails' + group.AccountGroup_Id"
          >
            <div class="row mt-4">
              <div class="col-auto px-0">
                <i style="visibility: hidden;">add</i>
              </div>
              <div class="col">
                <h6 class="text-secondary">Account</h6>
              </div>
              <div class="col">
                <h6 class="text-secondary">Location</h6>
              </div>
              <div class="col">
                <h6 class="text-secondary">Number of Users</h6>
              </div>
            </div>
            <div
              class="row pt-3"
              v-for="(account, index) in group.Accounts"
              :key="account.Account_Id"
              v-bind:class="{ 'light-background': index % 2 === 1 }"
            >
              <div class="col-auto px-0">
                <i
                  class="material-icons pointer"
                  v-bind:id="account.Account_Id + 'toggleIcon'"
                  data-toggle="collapse"
                  v-bind:href="'#accountDetails' + account.Account_Id"
                  role="button"
                  aria-expanded="false"
                  v-on:click="showAccountDetails(account.Account_Id)"
                  >add</i
                >
              </div>
              <div class="col">
                <h6 class="pointer btn-link d-inline-block">
                  {{
                    account.Organizations.find(
                      o => o.Parent_Organization_Id == 1
                    ).Name
                  }}
                </h6>
                <h6
                  v-if="account.Organizations.length != 1"
                  class="text-secondary d-inline-block ml-2"
                >
                  ({{ account.Organizations.length }} Organizations)
                </h6>
                <h6 v-else class="text-secondary d-inline-block ml-2">
                  ({{ account.Organizations.length }} Organization)
                </h6>
              </div>
              <div class="col">
                <p>{{ account.Billing_City }}, {{ account.Billing_State }}</p>
              </div>
              <div class="col">
                <p>
                  {{ account.Users.length }} / {{ account.Number_Of_Users }}
                </p>
              </div>

              <!-- Account Details -->
              <div
                class="container collapse ml-4"
                v-bind:id="'accountDetails' + account.Account_Id"
              >
                <div
                  class="mb-3"
                  style="background-color:gray; height:1px; width:100%"
                />
                <Account
                  v-if="
                    visibleAccounts.includes(
                      'accountDetails' + account.Account_Id
                    )
                  "
                  v-bind:AccountId="account.Account_Id"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CreateAccountGroupModal
      @addedAccountGroup="accountGroupAdded"
      @editedAccountGroup="accountGroupEdited"
      @editClosed="editAccountGroupClosed"
      v-bind:AccountGroup="accountGroupToEdit"
    />
    <CreateAccountModal
      @addedAccount="accountAdded"
      v-bind:AccountGroupId="newAccountGroupId"
    />
  </div>
</template>

<script>
import CreateAccountGroupModal from "@/modals/ManageAccounts/CreateAccountGroupModal.vue";
import CreateAccountModal from "@/modals/ManageAccounts/CreateAccountModal.vue";
import Account from "@/components/ManageAccounts/Account.vue";
import $ from "jquery";

export default {
  name: "AccountGroupList",
  components: {
    CreateAccountGroupModal,
    CreateAccountModal,
    Account
  },
  data() {
    return {
      accounts: "Something",
      accountGroups: [],
      newAccountGroupId: "-1",
      accountGroupToEdit: null,
      organizationTypes: [],
      visibleAccounts: []
    };
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    var view = this;
    try {
      view.$data.accountGroups = await view.$getGroupAccounts();
      view.$data.organizationTypes = (
        await view.$getOrganizationTypes()
      ).filter(o => o.Organization_Type_Id != 1);
      view.$store.commit("updateLoading", false);
    } catch (err) {
      console.log(err);
      view.$store.commit("updateLoading", false);
    }
  },
  methods: {
    accountGroupAdded(newAccountGroup) {
      var view = this;
      this.$data.accountGroups.push(newAccountGroup);
      setTimeout(function() {
        view.scrollToNewAccountGroup(newAccountGroup.AccountGroup_Id);
      }, 100);
    },
    scrollToNewAccountGroup(groupId) {
      var elmnt = document.getElementById(groupId);
      elmnt.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    },
    addAccountToGroup(groupId) {
      this.$data.newAccountGroupId = groupId;
      $("#createAccountModal").modal("show");
    },
    accountAdded(newAccount) {
      var accountGroupIndex = this.$data.accountGroups.findIndex(
        d => d.AccountGroup_Id == newAccount.AccountGroup_Id
      );
      this.$data.accountGroups[accountGroupIndex].Accounts.push(newAccount);
    },
    editAccountGroup(accountGroup) {
      this.accountGroupToEdit = accountGroup;
      $("#createAccountGroupModal").modal("show");
    },
    editAccountGroupClosed() {
      this.accountGroupToEdit = null;
    },
    accountGroupEdited(editedAccountGroup) {
      var editingIndex = this.accountGroups.findIndex(
        g => g.AccountGroup_Id == editedAccountGroup.AccountGroup_Id
      );
      this.$set(this.accountGroups, editingIndex, editedAccountGroup);
    },
    showAccountDetails(accountId) {
      this.$updateToggleIcon("#" + accountId + "toggleIcon");
      this.visibleAccounts.push("accountDetails" + accountId);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
